import BannerRoot from "../BannerRoot";
import styles from "./index.module.scss";
import React from "react";
import { useCalculatorController } from "../../context/context";
import {
  setShowGratitudeModal,
  submitGratitudeModal,
} from "../../context/actions";

const GratitudeModal = () => {
  const { dispatch } = useCalculatorController();

  return (
    <BannerRoot
      className={styles.modal}
      showCloseButton
      onClose={() => {
        setShowGratitudeModal(dispatch, false);
        submitGratitudeModal(dispatch, true);
      }}
    >
      <h3 className={styles.title}>
        Thank you! <br /> Your full metrics report has been unlocked!
      </h3>
    </BannerRoot>
  );
};

export default GratitudeModal;
